var xhr = require('xhr');
module.exports = require('./core')(xhr);
